<template>
  <article>
    <MaterialCard :videos="resources?.videos" :files="resources?.files" :show-always="showAlways" />
  </article>
</template>

<script>
import MaterialCard from '~/components/Cards/MaterialCard';
export default {
  name: 'DownloadMaterial',
  components: {
    MaterialCard
  },
  props: {
    resources: {
      type: Object,
      default: () => ({})
    },
    showAlways: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style src="./style.scss" lang="scss" />
